/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {AuthenticateParams, oauthAuthorisePost} from "../fn/oauth/authenticate-post";
import {AuthenticateResponseModel} from "../models/oauth/authenticate-response-model";
import {oAuthClientsGet, OAuthClientsGetParams} from "../fn/oauth/clients-get";
import {OAuthClientDetailsModel} from "../models/oauth/oauth-client-details-model";

@Injectable({ providedIn: 'root' })
export class OAuthService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /**
     * Authenticates a users credentials, and returns an authorization code if valid
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `authenticatePost()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    authenticatePost$Response(params: AuthenticateParams, context?: HttpContext): Observable<StrictHttpResponse<AuthenticateResponseModel>> {
        return oauthAuthorisePost(this.http, this.rootUrl, params, context);
    }

    /**
     * Authenticates a users credentials, and returns an authorization code if valid
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `authenticatePost$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    authenticatePost(params: AuthenticateParams, context?: HttpContext): Observable<AuthenticateResponseModel> {
        return this.authenticatePost$Response(params, context).pipe(
            map((r: StrictHttpResponse<AuthenticateResponseModel>): AuthenticateResponseModel => r.body)
        );
    }

    /**
     * For a given client ID, gets info relating to the client
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `clientsGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    clientsGet$Response(params: OAuthClientsGetParams, context?: HttpContext): Observable<StrictHttpResponse<OAuthClientDetailsModel>> {
        return oAuthClientsGet(this.http, this.rootUrl, params, context);
    }

    /**
     * For a given client ID, gets info relating to the client
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `clientsGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    clientsGet(params: OAuthClientsGetParams, context?: HttpContext): Observable<OAuthClientDetailsModel> {
        return this.clientsGet$Response(params, context).pipe(
            map((r: StrictHttpResponse<OAuthClientDetailsModel>): OAuthClientDetailsModel => r.body)
        );
    }
}
